namespace('arctic.views.common');

arctic.views.common.paymentSummary = function(viewport, options) {
	var $j = jQuery;
	var d = $j.dom;
	var _settings = options;
	var _viewport = viewport;
	var me = this;
	var _dateParse = compass.util.parse.ISODateParser;
	var _format = compass.util.dateFormatter('medium');
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	compass.startLoad('paymentSummary');

	var _labels = {
		headerText: "Payment Summary",
		cancellationInstructions: "Below is a detailed summary of payment transactions for your reservation. Pending transactions have not yet been processed and failed transactions were unable to be processed. Please review all hotel polices for details on deposit and cancellation charges.",
		transactionDateHeader: "Transaction Date",
		paymentHeader: "Payment",
		amountHeader: "Amount",
		occupantHeader: "Occupant",
		roomTypeHeader: "Room Type",
		checkInHeader: "Check-in",
		checkOutHeader: "Check-out"
	};

	var _drawBackButton = function() {
		return d.button({ className: "backButton secondaryButton"}, "&laquo; Back").activate(function() {
			_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
		});
	};

	var _drawHeader = function() {
		var header = d.div({ className: "headerTitle"}, _labels.headerText);
		var subHeader = d.div({ className: "subHeaderTitle"}, _pageJSON.groupName);
		var cancellationInstructions = d.div({ className: "cancellationInstructions"}, _labels.cancellationInstructions);

		return [header, subHeader, cancellationInstructions];
	};

	var _drawTransactionSummaryHeader = function() {
		var summaryHeader = d.div({ className: "summaryHeader"},
			d.div({ className: "transactionDateHeader"}, _labels.transactionDateHeader),
			d.div({ className: "paymentHeader"}, _labels.paymentHeader),
			d.div({ className: "amountHeader"}, _labels.amountHeader)
		);

		return summaryHeader;
	};

	var _drawTransactionDetail = function(rooms) {
		var rows = [];
		_.each(rooms, function(room) {
			// looks for HOUSING_CANCELLATION records that are associated with a HOUSING_REFUND that we don't want to show
			var skipHousingCancellationRecord = false;
			if (room.transactionType === "HOUSING_CANCELLATION") {
				queuedAmount = room.queuedAmount;
				attendanceId = room.attendanceId;
				_.some(rooms, function(cancelledRoom) {
					if (cancelledRoom.transactionType === "HOUSING_REFUND" && cancelledRoom.cancelFee === queuedAmount && cancelledRoom.attendanceId === attendanceId) {
						skipHousingCancellationRecord = true;
					}
				});
			}

			if (skipHousingCancellationRecord === false) {
				var checkIn = _format(_dateParse(room.checkIn));
				var checkOut = _format(_dateParse(room.checkOut));

				// want to show full refund amount if adjustment, not just queued amount
				if (room.transactionType === "HOUSING_REFUND") {
					var amount = room.assignedAmount;
				} else {
					var amount = room.queuedAmount;
				}

				// translate obligation codes to display verbiage
				var transactionTypeVerbiage = {
					"HOUSING": "Deposit",
					"HOUSING_REFUND": "Refund",
					"HOUSING_CANCELLATION": "Cancel Fee",
					"HOUSING_CANCELLATION_REFUND": "Refund",
					"HOUSING_SERVICE_FEE": "Service &amp; Technology Fee",
					"HOUSING_SERVICE_FEE_REFUND": "Refund"
				};
				var transactionTypeDisplay = transactionTypeVerbiage[room.transactionType] || room.transactionType;

				rows.push(d.tr({ className: "attendeeTransaction"},
					d.td({ className: "member"}, 
						d.div(room.occupantName),
						d.div(room.attendanceId)
					),
					d.td({ className: "room"},
						d.div(room.hotelName),
						d.div(room.roomType)
					),
					d.td({ className: "checkin"}, checkIn),
					d.td({ className: "checkOut"}, checkOut),
					d.td({ className: "amount"}, 
						d.div(_cf(amount)),
						d.div(transactionTypeDisplay)
					)
				));

				if (room.cancelledDate !== "") {
					var cancelledDate = _format(_dateParse(room.cancelledDate));
					if (transactionTypeDisplay === "Refund" && room.cancelFee > 0) {
						rows.push(d.tr(
							d.td({ className: "cancelFee", colspan: "5"},
								d.div(_cf(room.cancelFee)),
								d.div("Cancel Fee")
							)
						));
					}

					rows.push(d.tr(
						d.td({ className: "cancelled", colspan: "5"}, "Cancelled on " + cancelledDate)
					));
				}
			}
		});

		return rows;
	};

	var _drawTransactionSummary = function() {
		transactionSummaryContainer = d.div({ className: 'transactionSummaryContainer'});
		_.each(_pageJSON.paymentSummaryInfo, function(transaction) {
			var transactionOverview = d.div({ className: "transactionOverview"}, 
				d.div({ className: "transactionDate"}, _format(_dateParse(transaction[0].processedDate))),
				d.div({ className: "transactionPaymentInfo"}, transaction[0].nameOnCard + "'s " + transaction[0].payMethod + " ending in " + transaction[0].cardNumber),
				d.div({ className: "transactionStatus"}, transaction[0].paymentStatus + ": " + _cf(transaction[0].totalAmount))
			);

			var transactionSummaryTable = d.table({ className: "transactionSummary"},
				d.thead(
					d.tr({ className: "tableHeader"},
						d.th(_labels.occupantHeader),
						d.th(_labels.roomTypeHeader),
						d.th(_labels.checkInHeader),
						d.th(_labels.checkOutHeader),
						d.th(_labels.amountHeader)
					)
				),
				d.tbody(_drawTransactionDetail(transaction))
			);
			transactionSummaryContainer.append(transactionOverview);
			transactionSummaryContainer.append(transactionSummaryTable);
		});

		return transactionSummaryContainer;
	};

	var _render = function() {
		_viewport.append(
			d.div({ className: "header"}, 
				_drawBackButton(),
				_drawHeader()
			),
			d.div({ className: "paymentSummary"},
				_drawTransactionSummaryHeader(),
				_drawTransactionSummary()
			)
		);
	};

	this.run = function(renderComplete) {
		compass.loading.start();
		$j.ajax({
			url: '/paymentSummary',
			data: {},
			success: function(data) {
				compass.loading.stop();
				compass.stopLoad('paymentSummary');
				_pageJSON = data;

				if (_pageJSON.pageSpecificData.userType === "individual") {
					compass.trackPageView('PaymentSummaryIndividual');
				} else {
					compass.trackPageView('PaymentSummaryGroup');
				}

				_render();
				renderComplete();
			}
		});
	};
};